"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _qdKesiConnectStrings = require("../Strings/qdKesiConnectStrings");

var _index = _interopRequireDefault(require("../Button/index.js"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _ConnectHelper2 = _interopRequireDefault(require("../../../helpers/ConnectHelper"));

var _QDConnect = _interopRequireDefault(require("./QDConnect.scss"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableFooter = _interopRequireDefault(require("@material-ui/core/TableFooter"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QDConnect = /*#__PURE__*/function (_ConnectHelper) {
  (0, _inherits2["default"])(QDConnect, _ConnectHelper);

  var _super = _createSuper(QDConnect);

  function QDConnect(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, QDConnect);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showCopyCodeAlert", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var textFields;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                textFields = [{
                  label: (0, _qdKesiConnectStrings.getString)('CONNECT_CONNECTION_CODE'),
                  style: {
                    paddingBottom: '10px'
                  },
                  className: _QDConnect["default"].codeInput,
                  value: _this.connectionCode,
                  type: 'text',
                  InputProps: {
                    readOnly: true
                  }
                }];
                _this.removeAlertCallback = (0, _AlertHelper.showAlertHtmlWithTextfields)((0, _qdKesiConnectStrings.getString)('QDCONNECT_COPY_TEXT'), (0, _qdKesiConnectStrings.getString)('CONNECT_COPY_TITLE'), '', textFields);
              } catch (error) {
                (0, _AlertHelper.showAlertHtml)(error, (0, _qdKesiConnectStrings.getString)('FAILURE'), true);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showRemoveConnectionAlert", function () {
      var buttons = [{
        label: (0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL_CONNECTION'),
        callback: _this.removeConnection
      }];
      (0, _AlertHelper.showWideAlertHtml)((0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL_TEXT'), (0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL_TITLE'), true, buttons);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderByConnectionSatus", function () {
      if (!_this.state.isOnline) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _QDConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _qdKesiConnectStrings.getString)('CONNECT_OFFLINE')), /*#__PURE__*/_react["default"].createElement("br", null), (0, _qdKesiConnectStrings.getString)('QDCONNECT_GO_ONLINE')));
      } else if (_this.connectionCode && _this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS] && _this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS].length > 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _QDConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          value: _this.state.codeInput,
          label: (0, _qdKesiConnectStrings.getString)('CONNECT_CONNECTION_CODE'),
          onChange: _this.setCodeInput,
          type: 'text',
          error: _this.state.error,
          style: {
            width: "30%"
          },
          helperText: _this.state.error ? (0, _qdKesiConnectStrings.getString)('CONNECT_INSERT_ERROR') : ''
        }), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          theme: 'connectCode',
          className: _QDConnect["default"].button,
          onClick: _this.showCopyCodeAlert
        }, (0, _qdKesiConnectStrings.getString)('CONNECT_NO_CODE_YET')), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          onClick: function onClick() {
            return _this.checkCode();
          }
        }, (0, _qdKesiConnectStrings.getString)('CHECK_CONNECT_CODE')), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QDConnect["default"].title,
          style: {
            fontSize: '20px',
            marginTop: '50px'
          }
        }, (0, _qdKesiConnectStrings.getString)('CONNECT_CONNECTIONS')), /*#__PURE__*/_react["default"].createElement(_Table["default"], null, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_TableRow["default"], null, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, " applicationInstanceID "), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, " "))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, _this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS].map(function (id, index) {
          return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
            key: index
          }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, id), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, /*#__PURE__*/_react["default"].createElement(_index["default"], {
            onClick: function onClick() {
              return _this.removeConnection(id);
            }
          }, (0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL'))));
        }))));
      } else if (_this.connectionCode) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _QDConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          value: _this.state.codeInput,
          label: (0, _qdKesiConnectStrings.getString)('CONNECT_CONNECTION_CODE'),
          onChange: _this.setCodeInput,
          type: 'text',
          error: _this.state.error,
          style: {
            width: "30%"
          },
          helperText: _this.state.error ? (0, _qdKesiConnectStrings.getString)('CONNECT_INSERT_ERROR') : ''
        }), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          theme: 'connectCode',
          className: _QDConnect["default"].button,
          onClick: _this.showCopyCodeAlert
        }, (0, _qdKesiConnectStrings.getString)('CONNECT_NO_CODE_YET'))), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          onClick: function onClick() {
            return _this.checkCode();
          }
        }, (0, _qdKesiConnectStrings.getString)('CHECK_CONNECT_CODE')));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _QDConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null), /*#__PURE__*/_react["default"].createElement("p", null, (0, _qdKesiConnectStrings.getString)('CONNECT_LOADING')));
      }
    });
    _this.removeAlertCallback = null;
    return _this;
  }

  (0, _createClass2["default"])(QDConnect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(QDConnect.prototype), "componentDidMount", this).call(this);
      this.props.setBackButtonFunc(function () {
        return window.history.back();
      });
    }
  }, {
    key: "goHome",
    value: function goHome() {
      _NavigationManagerCordova["default"].goHome();
    }
  }, {
    key: "removeAlert",
    value: function removeAlert() {
      if (this.removeAlertCallback) {
        this.removeAlertCallback();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QDConnect["default"].mainWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QDConnect["default"].title
      }, (0, _qdKesiConnectStrings.getString)('QDCONNECT_TITLE')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _qdKesiConnectStrings.getString)('QDCONNECT_EXPLANATION_HEADER')), /*#__PURE__*/_react["default"].createElement("br", null), (0, _qdKesiConnectStrings.getString)('QDCONNECT_EXPLANATION_TEXT')), this.renderByConnectionSatus());
    }
  }]);
  return QDConnect;
}(_ConnectHelper2["default"]);

var _default = QDConnect;
exports["default"] = _default;